const letters = [
	{ letter: "A" },
	{ letter: "B" },
	{ letter: "C" },
	{ letter: "D" },
	{ letter: "E" },
	{ letter: "F" },
	{ letter: "G" },
	{ letter: "H" },
	{ letter: "I" },
	{ letter: "J" },
	{ letter: "K" },
	{ letter: "L" },
	{ letter: "M" },
	{ letter: "N" },
	{ letter: "O" },
	{ letter: "P" },
	{ letter: "Q" },
	{ letter: "R" },
	{ letter: "S" },
	{ letter: "T" },
	{ letter: "U" },
	{ letter: "V" },
	{ letter: "W" },
	{ letter: "X" },
	{ letter: "Y" },
	{ letter: "Z" }
];

export default letters;
